import { message } from 'antd'

export function handleRequestError(error) {
  if(error.is('connection_error')) {
    message.error('Ошибка соединения с сервером, проверьте интернет соединения.');
  } else {
    message.error(`Неизвестная ошибка: "${error.code}". Напишите на kwolfy11@gmail.com для поддержки`)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errors.js